/**
 * "How is this figure calculated?" hover popover — translucent midnight-blue
 * glass (blurred backdrop), small print. Pure CSS: revealed by the parent
 * `group` on hover/keyboard focus, never intercepts the pointer.
 */
export default function CalcHint({ lines }: { lines: string[] }) {
  return (
    <span
      role="tooltip"
      className="pointer-events-none absolute right-2 top-full z-30 mt-1 w-max max-w-[280px] rounded-lg border border-white/20 px-2.5 py-1.5 text-left opacity-0 shadow-[0_10px_28px_-10px_rgba(15,32,68,0.55)] backdrop-blur-md transition-opacity duration-150 group-hover:opacity-100 group-focus-visible:opacity-100"
      style={{ backgroundColor: 'rgba(30,64,120,0.62)' }}
    >
      <span className="block text-[8px] font-bold uppercase tracking-[0.14em] text-[#BCD2F5]">
        How this is calculated
      </span>
      {lines.map((line) => (
        <span key={line} className="mt-0.5 block text-[10px] font-medium leading-snug text-[#EAF2FF]">
          {line}
        </span>
      ))}
    </span>
  );
}
